import { message } from 'antd';
import { useState } from 'react';
import { useFormik } from 'formik';
import { UserHttp } from '@/services';
import { UserValidation } from '@/validations';
import { useTranslation } from 'react-i18next';

export default function useChangeCVV2() {

  const [t] = useTranslation([]);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      newCvv2: '',
      confirmNewCvv2: ''
    },
    validationSchema: UserValidation.changePasswordCVV2,
    onSubmit: async (values) => {
      setLoading(true);
      await UserHttp.changeCvv2({
        newCvv2: values.newCvv2,
        confirmNewCvv2: values.confirmNewCvv2
      }).finally(() => setLoading(false));
      message.success({ content: t('common:messages.success-cvv2-change') });
      formik.resetForm();
    },
  });

  return { formik, loading };

}
